import React, { useState } from "react";
import right_icon from '../../Assets/images/repairs/right_icon.png'
import location_diamond from '../../Assets/images/repairs/location-diamond.png'
import diamond_ring from '../../Assets/images/repairs/diamond-ring.png'
import search from '../../Assets/images/repairs/search.png'
import faq_banner from "../../Assets/images/repairs/faq_banner.png";
import { Link } from 'react-router-dom'
import {
  Form,
  FormGroup,
  Container,
  Button,
  FormControl,
  Row,
  Col, Accordion
} from "react-bootstrap";
import { base_url, postHeader } from "../../Helper/request";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Helmet } from "react-helmet";
import ReCAPTCHA from "react-google-recaptcha";

export const Repairs = () => {
  const specificDisabledDate = new Date('2025-08-04');
  const isDateDisabled = (date) => {
     const isFourthOfJuly = date.getDate() === 4 && date.getMonth() === 6;
      const isSunday = date.getDay() === 0; // Check if the date is Sunday (0 = Sunday)
      const isSpecificDate =
          date.getFullYear() === specificDisabledDate.getFullYear() &&
          date.getMonth() === specificDisabledDate.getMonth() &&
          date.getDate() === specificDisabledDate.getDate();

      return isSunday || isSpecificDate || isFourthOfJuly;
  };


  const metaData = useSelector((state) => state?.persistedReducer?.meta?.meta);
  const isWeekday = (date) => {
    const day = date.getDay();
    return day !== 0
  };
  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }
  function formatDate(date) {
    return [
      date.getFullYear(),
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
    ].join('-');
  }


  const storeLocation = useSelector(state => state.persistedReducer.home.store_locations)
  const clearAll = () => {
    setcontactData({
      ...contactData,
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      location: "",
      appointment_type: "",
      comment: "",
      date: "",
      time: ""
    })
  }

  const [contactData, setcontactData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    location: "",
    appointment_type: "",
    comment: "",
    date: "",
    time: "",
    request_type: 2
  });

  const[load,setLoad]=useState(false);
  
  const [validations, setValidations] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    location: "",
    appointment_type: "",
    comment: "",
    date: "",
    time: ""
  })
  const inputHandler = (e, type = "other") => {
    if (type === "typeDate") {
      setcontactData({
        ...contactData,
        date: e
      })
    } else {
      setcontactData({
        ...contactData,
        [e.target.name]: e.target.value
      })
    }

  }
  const validateAll = () => {
    const validations = {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      location: "",
      appointment_type: "",
      comment: "",
      date: "",
      time: ""
    }

    let isValid = true

    if (!contactData.phone) {
      validations.phone = 'Phone is required'
      isValid = false
    }
    if (contactData.phone && contactData?.phone.length < 10) {
      validations.phone = 'Phone must contain min 10 digits of number'
      isValid = false
    }

    if (!contactData.email) {
      validations.email = 'Email is required'
      isValid = false
    }
    if (!contactData.first_name) {
      validations.first_name = 'First name is required'
      isValid = false
    }
    if (!contactData.last_name) {
      validations.last_name = 'Last name is required'
      isValid = false
    }
    if (contactData.location === "") {
      validations.location = 'Location is required'
      isValid = false
    }
    if (contactData.appointment_type === "") {
      validations.appointment_type = 'Repair type is required'
      isValid = false
    }
    if (contactData.time === "") {
      validations.time = 'Time is required'
      isValid = false
    }
    if (contactData.date === "") {
      validations.date = 'Date is required'
      isValid = false
    }


    if (contactData.email && !/\S+@\S+\.\S+/.test(contactData.email)) {
      validations.email = 'Email format must be as example@mail.com'
      isValid = false
    }

    if (!isValid) {
      setValidations(validations)
    }

    return isValid
  }
  const validateOne = (e) => {
    const { name } = e.target;
    const value = contactData[name];
    let message = ''

    if (!value) {
      message = `${name==="appointment_type" ? "Repair Type" : name} is required`
    }
    if (value!=="" && name === 'date' ) {
      message = ''
    }
    if (value && name === 'email' && !/\S+@\S+\.\S+/.test(value)) {
      message = 'Email format must be as example@mail.com'
    }
    if (value && name === 'phone' && /^\d{9}$/.test(value)) {
      message = 'Phone number must be in 10 digits'
    }

    setValidations({ ...validations, [name]: message })
  }
  const onSubmit = (e) => {
    e.preventDefault();
    const isValid = validateAll()
    if (!isValid) {
      return false
    }

    setLoad(true);

    const options = {
      method: "POST",
      headers: postHeader
    };

    const payload={
      first_name: contactData?.first_name ? contactData?.first_name : "",
      last_name: contactData?.last_name ? contactData?.last_name : "",
      email: contactData?.email ? contactData?.email : "",
      phone: contactData?.phone ? contactData?.phone : "",
      location: contactData?.location ? contactData?.location : "",
      appointment_type: contactData?.appointment_type ? contactData?.appointment_type : "",
      comment: contactData?.comment ? contactData?.comment : "",
      date: contactData?.date ? formatDate(contactData?.date) : "",
      time: contactData?.time ? contactData?.time : "",
      request_type: 2
    }
  //   window.woopra.track("repair", {
  //     email: contactData?.email ? contactData?.email : "",
  //     fname: contactData?.first_name ? contactData?.first_name : "",
  //     lname:contactData?.last_name ? contactData?.last_name : "",
  //     name: contactData?.first_name ? contactData?.first_name : "" + " " + contactData?.last_name ? contactData?.last_name : "",
  //     phone:contactData?.phone ? contactData?.phone : "",
  //     repair_type:contactData?.appointment_type ? contactData?.appointment_type : "",
  //     location:contactData?.location ? contactData?.location : "",
  //     date:contactData?.date ? formatDate(contactData?.date) : "",
  //     time:contactData?.time ? contactData?.time : "",
  //     notes: contactData?.comment ? contactData?.comment : ""
  // });
    axios.post(base_url + "/common/makeAppointment", payload, options).then((res) => {
      if (res?.data?.status === 1) {
        toast.success(res?.data?.message);
        clearAll();
        setLoad(false);
      } else {
        toast.error(res?.data?.message);
      }
    });
  };
  const [captchaStatus, setcaptchaStatus] = useState(true);
  const capthcaHandle = (res) => {
      if (res) {
        setcaptchaStatus(false);
      }
    };
  return (
    <>
            <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title ? metaData?.meta_title : "Wedding Day Diamonds"}</title>
        <meta
          name="description"
          content={metaData?.meta_desp}
        ></meta>
        <meta name="keywords" content={metaData?.meta_keywords}></meta>
      </Helmet>
      <ToastContainer />
      <section className='repairs_banner text-center'>
        <h1>REPAIRS</h1>
      </section>

      <section className='repairs-overview text-center '>
        <Container>
          <Row className='justify-content-center'>
            <Col md={8} className="p-0">
              <svg width="80" height="80" viewBox="0 0 136 173" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M60.9748 64.1323C60.3668 64.1323 59.7528 63.8923 59.2858 63.4243L16.0038 20.1472C15.5358 19.6852 15.2958 19.0362 15.3078 18.3762C15.3308 17.7222 15.6168 17.0972 16.1088 16.6642C16.2658 16.5362 30.4638 3.97426 33.3458 1.17426C33.7898 0.748255 34.4038 0.490234 35.0118 0.490234H88.9158C89.5528 0.490234 90.1598 0.760242 90.6168 1.19824L106.072 16.6403C106.516 17.0963 106.768 17.7092 106.768 18.3292C106.768 18.9612 106.516 19.5743 106.072 20.0303L62.6778 63.4243C62.2078 63.8923 61.5878 64.1323 60.9748 64.1323ZM21.1988 18.5573L60.9748 58.3333L100.985 18.3292L87.9218 5.29425H35.9708C32.8768 8.18725 24.8938 15.2893 21.1988 18.5573Z" fill="#3F5654" />
                <path d="M63.3839 3.3833H58.5959V61.7293H63.3839V3.3833Z" fill="#3F5654" />
                <path d="M104.369 16.0625H17.7039V20.8555H104.369V16.0625Z" fill="#3F5654" />
                <path d="M63.2599 62.5125L59.0229 60.2844L81.632 17.1425L75.267 3.92743L79.562 1.85742L86.986 17.2354L63.2599 62.5125Z" fill="#3F5654" />
                <path d="M59.0867 63.2024L35.3438 17.9254L42.7787 2.54736L47.0748 4.61639L40.6987 17.8314L63.3187 60.9753L59.0867 63.2024Z" fill="#3F5654" />
                <path d="M62.8509 172.733C28.4589 172.733 0.483887 144.759 0.483887 110.378C0.483887 75.9965 28.4589 48.0215 62.8509 48.0215C97.2319 48.0215 125.207 75.9965 125.207 110.378C125.207 144.759 97.2319 172.733 62.8509 172.733ZM62.8509 52.8095C31.1009 52.8095 5.27087 78.6285 5.27087 110.378C5.27087 142.111 31.0999 167.928 62.8509 167.928C94.5839 167.928 120.414 142.111 120.414 110.378C120.414 78.6275 94.5839 52.8095 62.8509 52.8095Z" fill="#3F5654" />
                <path d="M63.0259 141.141C62.2309 141.141 61.4769 140.744 61.0389 140.07C49.6059 122.944 34.4029 107.864 28.4059 102.176C27.4469 101.265 27.4129 99.7442 28.3179 98.7862C29.2419 97.8282 30.7379 97.7922 31.7079 98.6932C37.4659 104.159 51.5468 118.128 62.9378 134.39C71.0208 121.641 102.744 73.0511 130.899 48.7011C131.892 47.8521 133.722 47.6482 134.593 48.6422C135.469 49.6232 135.71 50.8451 134.739 51.7171C134.728 51.7171 134.044 52.3182 134.032 52.3302C102.182 79.8612 65.4279 139.393 65.0599 139.99C64.6389 140.697 63.8849 141.118 63.0719 141.141H63.0259Z" fill="#3F5654" />
              </svg>
              <p>If you purchased your jewelry from Wedding Day Diamonds, all repairs are free for life, no questions asked. <br /><br /> Not from Wedding Day Diamonds? No problem! We will evaluate your jewelry to determine the estimated cost of repairs.</p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='repairs-features'>
        <ul className='repairs-features-list'>
          <li>
            <img src={right_icon} alt='repairs' />
            <h3>EXPERIENCE</h3>
            <p>In the jewelry business for 47 years.</p>
          </li>
          <li>
            <img src={right_icon} alt='repairs' />
            <h3>GUARANTEE</h3>
            <p>90 day guarantee on repairs.</p>
          </li>
          <li>
            <img src={right_icon} alt='repairs' />
            <h3>FREE</h3>
            <p>Free Cleaning and inspection, anytime.</p>
          </li>
          <li>
            <img src={right_icon} alt='repairs' />
            <h3>SPECIAL</h3>
            <p> 20% off on your first repair.</p>
          </li>
          <li>
            <img src={right_icon} alt='repairs' />
            <h3>Fast</h3>
            <p>Expert in-house repairs, never outsourced.</p>
          </li>
        </ul>
      </section>

      <section className='repires-find-location'>
        <Container>
          <Row className='justify-content-center'>
            <Col md={12}>
              <div className='repires-find-location-inner d-flex'>
                <div className='repires-find-location-diamond'>
                  <div>
                    <img src={location_diamond} alt='diamond' />
                    <p>If you've got a question or a repair that seems more complicated, please feel free to fill out this form and set up a time to meet with our experts.</p>
                  </div>
                </div>
                <div className='repires-find-location-overlay'>
                  <div>
                    <p>The best way to get your jewelry repaired is to stop into one of our showrooms. No appointment necessary.</p>
                    <Link to='/showroom'>FIND A LOCATION</Link>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className='repaires-appointment-form'>
        <Container className="contact_fotm appintment-form">
          <h2 className="text-center mb-5 theme_color subtitle">
            MAKE AN APPOINTMENT
          </h2>
          <Form onSubmit={onSubmit}>
            <Row>
              <Col md={6} className="left-div">
                <Form.Group className="contact-input f-name" controlId="formBasicFname">
                  <div className="d-flex align-items-center">
                    <Form.Label>
                      First Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control type="text" placeholder="First Name" value={contactData?.first_name} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='first_name' />

                  </div>
                  {
                    validations?.first_name && <div className='validation mt-1'>
                      {validations?.first_name.replace("_", " ")}
                    </div>
                  }
                </Form.Group>
                <Form.Group className="contact-input l-name" controlId="formBasicLname">
                  <div className="d-flex align-items-center">
                    <Form.Label>
                      Last Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control type="text" placeholder="Last Name" value={contactData?.last_name} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='last_name' />
                  </div>
                  {
                    validations?.last_name && <div className='validation mt-1'>
                      {validations?.last_name.replace("_", " ")}
                    </div>
                  }
                </Form.Group>
                <Form.Group className="contact-input emailadd" controlId="formBasicEmail">
                  <div className="d-flex align-items-center">
                    <Form.Label>
                      Email <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control value={contactData?.email} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='email' type="email" placeholder="email" />
                  </div>
                  {
                    validations?.email && <div className='validation mt-1'>
                      {validations?.email.replace("_", " ")}
                    </div>
                  }
                </Form.Group>
                <Form.Group className="contact-input phoneno" controlId="formBasicPhone">
                  <div className="d-flex align-items-center">
                    <Form.Label>
                      Phone Number <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control value={contactData?.phone} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='phone' type="number" placeholder="Phone Number" />

                  </div>
                  {
                    validations?.phone && <div className='validation mt-1'>
                      {validations?.phone.replace("_", " ")}
                    </div>
                  }
                </Form.Group>
                <Form.Group className="contact-input location" controlId="formBasicPhone">
                  <div className="d-flex align-items-center">
                    <Form.Label>
                      TYPE OF REPAIR<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select aria-label="Location" onChange={(e) => inputHandler(e)} onBlur={validateOne} name='appointment_type'>
                      <option>TYPE OF REPAIR</option>
                      <option value="Ring sizing">Ring sizing</option>
                      <option value="Engraving">Engraving</option>
                      <option value="Refurbishing and polishing">Refurbishing and polishing</option>
                      <option value="Rhodium plating">Rhodium plating</option>
                      <option value="Ring removal">Ring removal</option>
                      <option value="Chain repair">Chain repair</option>
                      <option value="Soldering">Soldering</option>
                      <option value="Stone tightening">Stone tightening</option>
                      <option value="+ MORE">+ MORE</option>
                      <option value="Diamond setting">Diamond setting</option>
                      <option value="Custom work">Custom work</option>
                    </Form.Select>

                  </div>
                  {
                    validations?.appointment_type && <div className='validation mt-1'>
                      {validations?.appointment_type.replace("_", " ")}
                    </div>
                  }
                </Form.Group>
                <FormGroup
                  className="contact-input location"
                  controlId="formControlsSelect"
                >
                  <div className="d-flex align-items-center">
                    <Form.Label>
                      Choose a Location <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select aria-label="Location" value={contactData?.location} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='location'>
                      <option>Location</option>
                      {storeLocation?.map(stores =>
                        <option value={stores.location}>{stores.location}</option>
                      )}
                    </Form.Select>
                  </div>
                  {
                    validations?.location && <div className='validation mt-1'>
                      {validations?.location.replace("_", " ")}
                    </div>
                  }
                </FormGroup>
              </Col>
              <Col md={6} className="right-div">
                <Form.Group className="contact-input date" controlId="formBasicPhone">
                  <div className="d-flex align-items-center">
                    <Form.Label>
                      Choose a Date<span className="text-danger">*</span>
                    </Form.Label>
                    <DatePicker placeholderText="Choose Date"
                      minDate={new Date()}
                      filterDate={(date) => !isDateDisabled(date)}
                      className='form-control w-100'
                      selected={contactData?.date}
                      onChange={(e) => inputHandler(e, "typeDate")}
                      onBlur={validateOne} name='date' />
                    {/* <Form.Control value={contactData?.date} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='date' type="date" placeholder="Choose a Date" /> */}
                  </div>
                  {
                    validations?.date && <div className='validation mt-1'>
                      {validations?.date.replace("_", " ")}
                    </div>
                  }
                </Form.Group>
                <Form.Group className="contact-input time" controlId="formBasicPhone">
                  <div className="d-flex align-items-center">
                    <Form.Label>
                      Choose a Time<span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select aria-label="Choose a Time" value={contactData?.time} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='time'>
                      <option>Choose a Time</option>
                      <option value="11:00 am">11:00 am</option>
                      <option value="12:00 pm">12:00 pm</option>
                      <option value="1:00 pm">1:00 pm</option>
                      <option value="2:00 pm">2:00 pm</option>
                      {/* <option value="11:00 am">11:00 am</option>
                      <option value="11:30 am">11:30 am</option>
                      <option value="12:00 pm">12:00 pm</option>
                      <option value="12:30 pm">12:30 pm</option> */}
                      
                    </Form.Select>
                  </div>
                  {
                    validations?.time && <div className='validation mt-1'>
                      {validations?.time.replace("_", " ")}
                    </div>
                  }
                </Form.Group>
                <FormGroup className="contact-input comment" controlId="formControlsTextarea">
                  <div className="d-flex align-items-center">
                    <Form.Label className="desktop_hide">
                      ADDTIONAL NOTES{" "}
                    </Form.Label>
                    <FormControl
                      as="textarea"
                      componentClass="textarea"
                      placeholder="ADDTIONAL NOTES"
                      value={contactData?.comment} onChange={(e) => inputHandler(e)} onBlur={validateOne} name='comment'
                    />
                  </div>
                </FormGroup>
                <div className='mt-3'>
                        <ReCAPTCHA
  sitekey="6Lc6LUscAAAAAKO2DYPGrIPSnwx3fzROCxJzNWQ0"
    onChange={capthcaHandle}
  />
                        </div>
                <Button disabled={captchaStatus ? true : false} variant="primary1" className="theme_btn" type="submit">
                  {load ? "Sending..." : "SUBMIT"}
                </Button>
              </Col>
            </Row>
          </Form>
        </Container>
      </section>

      <section className="repairs-note">
        <img src={diamond_ring} alt="Diamond-ring" />FREE JEWELRY CLEANING & INSPECTION, FOR EVERYONE AT ANYTIME!
      </section>

      <section className="repair-services">
        <Container >
          <h2 className="repair-services-title"><img src={search} alt="REPAIR SERVICES" /> REPAIR SERVICES</h2>
          <Row>
            <Col md={4}>
              <ul className="repaire-list">
                <li>Ring sizing</li>
                <li>Rhodium plating</li>
                <li>Soldering</li>
                <li> Diamond setting</li>
              </ul>
            </Col>
            <Col md={4}>
              <ul className="repaire-list">
                <li>Engraving</li>
                <li>Ring removal</li>
                <li>Stone tightening</li>
                <li>Custom work</li>
              </ul>
            </Col>
            <Col md={4}>
              <ul className="repaire-list">
                <li>Refurbishing and polishing</li>
                <li> Chain repair</li>
                <li><span>+ MORE</span></li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="repair-faq">
        <div className="customedesign_faq">
          <Row>
            <Col className="customedesign_faq_left">
              <img src={faq_banner} alt="" className="img-fluid" />
            </Col>
            <Col className="customedesign_faq_right">
              <div className="customedesign_faq_right_inner">
                <h2 className="title mb-3 mb-lg-5">FREQUENTLY ASKED QUESTIONS</h2>
                <Accordion className="your_order_includes_inner">
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      HOW LONG DO REPAIRS TAKE?
                    </Accordion.Header>
                    <Accordion.Body>Most repairs take one week to complete. Your repair will go into a queue based on the day you drop it off at one of our stores. If you need something done quickly, please give our stores a call or submit an appointment request above.</Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>DO I NEED TO HAVE MY JEWELRY INSPECTED?</Accordion.Header>
                    <Accordion.Body>Our NO FINE PRINT WARRANTY does NOT require any inspections. However, it is recommended to get your jewelry cleaned and inspected about every 6 months. If there is something that needs to be done, we will let you know and make arrangements to have it repaired. </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>WHAT IS A CLEAN AND CHECK?</Accordion.Header>
                    <Accordion.Body>A clean and check is the process of inspecting your jewelry. Stop in anytime and ask for a clean and check! It's FREE! A representative will take a look at your jewelry under a microscope, check for any loose stones or other damage that may need to be addressed. If everything looks great, we will professionally clean and steam it for you while you wait. If there are repairs needed, we will let you know and help you get it taken care of.</Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>MY WHITE GOLD RING IS TURNING YELLOW; WHAT DO I DO?</Accordion.Header>
                    <Accordion.Body>All white gold has a plating called rhodium on it. It is rhodium that creates the white metal color on your ring. Over time, this plating can wear off. When this occurs, simply bring in your ring to get re-rhodium plated and polished. We recommend doing this no more than once a year in order to keep the integrity of your ring for as long as possible. </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Link to='/customer-service/custom-design-faq' className="more-faq"> <span>More FAQ's</span></Link>
              </div>
            </Col>
          </Row>
        </div>
      </section>



    </>
  )
}
